import classnames from "classnames";
import React from "react";
import { Badge } from "reactstrap";

/**
 * Represents an Avatar component that displays an image or content with optional badge and status.
 * @constructor
 * @param {Object} props - The properties of the Avatar component.
 * @param {string} props.color - The color of the avatar background.
 * @param {string} props.className - The additional CSS class for styling.
 * @param {string} props.size - The size of the avatar (sm, lg, xl).
 * @param {boolean} props.img - Flag to determine if the avatar should display an image.
 * @param {string} props.content - The content to display inside the avatar.
 * @param {ReactNode} props.icon - The icon element to display inside the avatar.
 * @param {boolean} props.badgeUp - Flag to show a badge on top of the avatar.
 * @param {string} props.badgeColor - The color of the badge.
 * @param {string} props.badgeText - The text to display in the badge.
 * @param {string} props.imgHeight - The height of the avatar image.
 * @param {string} props.imgWidth - The width of the avatar image.
 * @param {string} props.status - The status of the avatar (online, offline, away, etc.).
 */
class Avatar extends React.Component {
  render() {
    return (
      <div
        className={classnames(
          `avatar ${this.props.color ? `bg-${this.props.color}` : null}  ${
            this.props.className
          }`,
          {
            "avatar-sm": this.props.size && this.props.size === "sm",
            "avatar-lg": this.props.size && this.props.size === "lg",
            "avatar-xl": this.props.size && this.props.size === "xl",
          }
        )}
      >
        {this.props.img === false || this.props.img === undefined ? (
          <span
            className={classnames("avatar-content", {
              "position-relative": this.props.badgeUp,
            })}
          >
            {this.props.content ? this.props.content : null}

            {this.props.icon ? (
              <div className="avatar-icon">{this.props.icon}</div>
            ) : null}
            {this.props.badgeUp ? (
              <Badge
                color={
                  this.props.badgeColor ? this.props.badgeColor : "primary"
                }
                className="badge-sm badge-up"
                pill
              >
                {this.props.badgeText ? this.props.badgeText : "0"}
              </Badge>
            ) : null}
          </span>
        ) : (
          <img
            src={this.props.img}
            alt="avatarImg"
            height={
              this.props.imgHeight && !this.props.size
                ? this.props.imgHeight
                : 32
            }
            width={
              this.props.imgWidth && !this.props.size ? this.props.imgWidth : 32
            }
          />
        )}
        {this.props.status ? (
          <span className={`avatar-status-${this.props.status}`}></span>
        ) : null}
      </div>
    );
  }
}
export default Avatar;
